import React from 'react';
import ReactLoading from 'react-loading';

const Loading = () => {
  return(
    <ReactLoading type="spokes" className="container" color="#111111" height={'20'} width={'20%'} />
  )
}
export default Loading



// WEBPACK FOOTER //
// ./src/components/Loding/Loading.js